import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { ActionLogsPanel } from "./ActionLogsPanel";
import { EmailAdminActions } from "./EmailAdminActions";
import { PipelinePresentationDrawer } from "./PipelinePresentationDrawer";

interface AdminEmailPanelProps {
  emailId?: string;
  messageId?: string;
  inboxEmail?: string;
  sharedInbox?: string;
}

/**
 * Admin-only panel for email operations
 * Contains action logs and admin actions dropdown
 */
export const AdminEmailPanel: React.FC<AdminEmailPanelProps> = ({
  emailId,
  messageId,
  inboxEmail,
  sharedInbox,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const canShowPipeline = !!(emailId || (messageId && inboxEmail));

  return (
    <Box sx={{ mb: 2 }}>
      {/* Admin Actions Dropdown */}
      <EmailAdminActions
        emailId={emailId}
        messageId={messageId}
        inboxEmail={inboxEmail}
        sharedInbox={sharedInbox}
      >
        {canShowPipeline && (
          <Button
            variant="outlined"
            size="small"
            onClick={() => setDrawerOpen(true)}
          >
            Show Pipeline Results
          </Button>
        )}
      </EmailAdminActions>

      {/* Action Logs Panel - only show if emailId is available */}
      {emailId && <ActionLogsPanel emailId={emailId} />}

      {/* Pipeline Presentation Drawer */}
      {canShowPipeline && (
        <PipelinePresentationDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          emailId={emailId}
          messageId={messageId}
          sharedInbox={sharedInbox}
          inboxEmail={inboxEmail}
        />
      )}
    </Box>
  );
};
